import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { IconSeeker, TooltipSeeker } from '@ui-seeker/core'
import { dsColorNew } from '@palette'

import { REAL_TIME_ROUTES, REPORT_STATUS, BACKEND_APIS } from '@constants'
import { AppButtonIcon, AppRunProgress } from '@components'
import { batchIdStatusList, batchTableCellData } from 'Pages/Batch/Page/@signals'
import { formatDate, getExcel } from '@ui-seeker/utils'
import { dateFormatReceiver } from '@utils'
import { reportSearchesModalId } from '@signals'
import { useComputed } from '@preact/signals-react'


export default function historyColumn() {

	return {
		name: 'id_batch', label: 'Status',
		options: {
			filter: false,
			customBodyRowRenderLite: (idBatch, row) => <CellContent idBatch={idBatch} row={row}/>,
		},
	}
}


function CellContent({ idBatch, row }) {
	const rowData = useComputed(() => ({ ...row, ...batchTableCellData.value[idBatch] }))
	const isRunning = useComputed(() => rowData.value?.status === REPORT_STATUS.RUNNING)

	useEffect(() => {
		if (isRunning.value) {
			batchIdStatusList.value = [...batchIdStatusList.value, idBatch]
		}
	}, [idBatch])

	const updated = format => formatDate(rowData.value?.timestamp_update_tz, {
		isString: true,
		format,
		receivedFormat: dateFormatReceiver(rowData.value?.timestamp_update_tz)
	})
	const openHistorical = e => {
		window.open(`${REAL_TIME_ROUTES.HISTORY_PATH}?idBatch=${row.id_batch}`)
		if (e.ctrlKey) e.preventDefault()
	}
	const openExport = e => {
		window.open(row?.export_url)
		if (e.ctrlKey) e.preventDefault()
	}

	// One line for the state (date, Stopped or the progress card), one for the counters and the actions
	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.75, width: '100%' }}>
		{rowData.value?.status === REPORT_STATUS.STOPPED
			? <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
				<Box sx={{ fontSize: 13, color: dsColorNew.textTitle }}>{updated('dd MMM yyyy HH:mm')}</Box>
				<Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, fontSize: 12, fontWeight: 600, color: dsColorNew.dangerRed, backgroundColor: dsColorNew.dangerBg, borderRadius: '6px', px: 1, py: 0.25 }}>
					<IconSeeker icon="hand" sx={{ fontSize: 12, color: 'inherit' }}/> Stopped
				</Box>
			</Box>
			: <>
				<Box sx={{ fontSize: 13, color: dsColorNew.textTitle }}>
					{updated('dd MMM yyyy')} <Box component="span" sx={{ color: dsColorNew.textMuted }}>{updated('HH:mm:ss')}</Box>
				</Box>
				{isRunning.value && <AppRunProgress
					actual={rowData.value?.completeTasks}
					total={rowData.value?.totalTasks}
					done={rowData.value?.completeTasksString}
					totalText={rowData.value?.totalTasksString}
					generating={rowData.value?.generating}
					onClick={() => {
						if (rowData.value?.status !== REPORT_STATUS.GENERATING) {
							reportSearchesModalId.value = rowData.value?.id_batch
						}
					}}
				/>}
			</>
		}

		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.75 }}>
			<StatusCounter icon="triangle-exclamation" tooltip="Search Errors" value={row?.errorTasks} color={dsColorNew.noteAmber} bg={dsColorNew.noteAmberBg}/>
			<StatusCounter icon="calendar-circle-exclamation" tooltip="N/A Results" value={row?.naTasks} color={dsColorNew.dangerRed} bg={dsColorNew.dangerBg}/>
			<Box sx={{ width: '1px', height: 20, backgroundColor: dsColorNew.grayBorder, mx: 0.5 }}/>
			{row.export && row?.exported && row?.export_url && <AppButtonIcon
				iconWeight="regular"
				icon="cloud-arrow-down"
				tooltip="Download Export"
				onClick={openExport}
				onAuxClick={e => {
					if (e.button === 1) {
						window.open(row?.export_url)
						e.preventDefault()
					}
				}}
			/>}
			<AppButtonIcon
				iconWeight="solid"
				icon="clock-rotate-left"
				tooltip="View Historical"
				onClick={openHistorical}
				onAuxClick={e => {
					if (e.button === 1) {
						window.open(`${REAL_TIME_ROUTES.HISTORY_PATH}?idBatch=${row.id_batch}`)
						e.preventDefault()
					}
				}}
			/>
			<AppButtonIcon
				iconWeight="regular"
				icon="file-excel"
				tooltip="Download Batch Excel"
				onClick={() => getExcel(`${BACKEND_APIS.BATCH}/excel`, {idBatch: row.id_batch})}
			/>
		</Box>
	</Box>
}


function StatusCounter({ icon, tooltip, value, color, bg }) {
	return <TooltipSeeker title={tooltip}>
		<Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6, height: 24, px: 1, borderRadius: '6px', fontSize: 12, fontWeight: 600, color, backgroundColor: bg }}>
			<IconSeeker icon={icon} iconWeight="regular" sx={{ fontSize: 12, color: 'inherit' }}/>
			{value}
		</Box>
	</TooltipSeeker>
}
